import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';


const rows = [
  {
    product: 'Estética audiovisual (en estudio)',
    detail:
      'Producción en TNO (formato híbrido televisión y podcast en streaming); set Expedientes del Delito; 2 reels mensuales cinematográficos en estudio.',
  },
  {
    product: 'Frases de autoridad (historias)',
    detail: 'Streaming 24/7: 3 historias semanales con voces Angélica y Santiago; contenido permanente en el programa y biblioteca TNO.',
  },
  {
    product: 'Micro «Expediente Danimar»',
    detail: 'Una presencia en el set por emisión; guion dual; inserts en programa; logo en mini-site del show.',
  },
  {
    product: 'TNO Digest y SEO (informe técnico)',
    detail: '2 informes al mes firmados por Angélica Lugo; titular SEO sugerido; autoridad orgánica en Google.',
  },
];

const InvestmentSummary = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Resumen
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Plan de Inversión: Operativo Danimar
        </Box>
      </Box>
      <TableContainer
        component={Paper}
        elevation={2}
        sx={{ maxWidth: 760, mx: 'auto', borderRadius: 2 }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: theme.palette.primary.main }}>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Concepto</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Descripción</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={i} hover>
                <TableCell>{row.product}</TableCell>
                <TableCell>{row.detail}</TableCell>
              </TableRow>
            ))}
            <TableRow sx={{ bgcolor: theme.palette.primary.main }}>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>INVERSIÓN MENSUAL TOTAL</TableCell>
              <TableCell align="right" sx={{ color: 'white', fontWeight: 700 }}>
                $300
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ maxWidth: 760, mx: 'auto', mt: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="textSecondary" paragraph>
          Plan <strong>Operativo Danimar</strong> ($300/mes), alineado a los cuatro pilares de campaña: estética y reels en
          estudio; 3 historias semanales en streaming que quedan para siempre en el programa; micro dual en{' '}
          <strong>Expedientes del Delito</strong> (una presencia en el set por emisión, inserts en el programa y logo en el
          mini-site del show);
          informes en TNO Digest y SEO (Angélica Lugo).
        </Typography>
      </Box>
      <PriceVatDisclaimer />
    </Box>
  );
};

export default InvestmentSummary;

